import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const Check3 = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      viewBox="0 0 37 37"
      width={size}
      height={size}
      color={iconColor}
      fill={iconColor}
      style={{ overflow: 'visible' }}
    >
      <title>{iconTitle}</title>
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M36.9999435,17.3492287 L36.9999435,19.0051194 C36.9953856,26.9762273 31.7480875,33.9949124 24.1036143,36.2550015 C16.4591411,38.5150905 8.23853312,35.4781929 3.89975614,28.7911922 C-0.439020846,22.1041916 0.137601805,13.3600425 5.31692653,7.30062247 C10.4962513,1.24120249 19.044477,-0.690033967 26.3259737,2.55420619"
          stroke="#28A745"
          strokeWidth="3"
        />
        <polyline
          stroke="#28A745"
          strokeWidth="3"
          points="36.9999435 4.99508646 19.3076358 22.9950865 13.9999435 17.6004811"
        />
      </g>
    </svg>
  );
};

Check3.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

Check3.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(Check3);
